var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 132,
    viewBox: "0 0 120 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_295_1114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.334 45.3333C38.334 45.3333 43.5573 39.5 50.0007 39.5C56.4439 39.5 61.6673 45.3333 61.6673 45.3333",
    stroke: "#FF4500",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1353 51.2195C61.49 51.7168 61.6673 51.9656 61.6673 52.3337C61.6673 52.7017 61.49 52.9505 61.1353 53.4478C59.5415 55.6827 55.4714 60.5003 50.0007 60.5003C44.5299 60.5003 40.4598 55.6827 38.866 53.4478C38.5113 52.9505 38.334 52.7017 38.334 52.3337C38.334 51.9656 38.5113 51.7168 38.866 51.2195C40.4598 48.9846 44.5299 44.167 50.0007 44.167C55.4714 44.167 59.5415 48.9846 61.1353 51.2195Z",
    stroke: "#FF4500",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 52.333C53.5 50.4 51.933 48.833 50 48.833C48.0669 48.833 46.5 50.4 46.5 52.333C46.5 54.2661 48.0669 55.833 50 55.833C51.933 55.833 53.5 54.2661 53.5 52.333Z",
    stroke: "#FF4500",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_295_1114",
    x: -20,
    y: -8,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_1114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_295_1114",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.c1f41d1889a1e0651b22b48904d53f4e.svg";
export { ForwardRef as ReactComponent };